import type { FC } from 'react';
import Icon from '@components/Icon';
import IconMdi from '@components/IconMdi';
import { Show } from '@components/Show';
import type { SvgIconName } from '@components/Svg';
import { mdiArrowRight } from '@mdi/js';
import { twMerge } from 'tailwind-merge';

interface StepperCardProps {
  className?: string;
  cta: string;
  'data-testid'?: string;
  description: string;
  icon?: string;
  onClick?: () => void;
  svgName?: SvgIconName;
}

export const StepperCard: FC<StepperCardProps> = ({
  className,
  cta,
  description,
  icon,
  onClick,
  svgName,
  ...props
}) => {
  'use memo';
  return (
    <div
      onClick={onClick}
      className={twMerge(
        'inline-flex h-32 w-52 cursor-pointer flex-col items-start justify-start rounded-lg bg-white shadow-sm',
        className,
      )}
      {...props}
    >
      <div className="inline-flex items-start justify-start gap-5 self-stretch px-4 pt-4 pb-6">
        <div className="bg-primary-600 relative flex h-10 w-10 items-center justify-center rounded-md">
          <Show when={!!icon}>
            <IconMdi path={icon!} className="relative h-6 w-6 text-white" />
          </Show>
          <Show when={!!svgName}>
            <div>
              <Icon name={svgName!} className="text-white" />
            </div>
          </Show>
        </div>
        <div className="inline-flex shrink grow basis-0 flex-col items-start justify-start">
          <div className="text-info-900 self-stretch text-sm leading-tight">{description}</div>
        </div>
      </div>
      <div className="bg-info-50 flex h-12 grow flex-col items-start justify-center self-stretch px-4 py-3">
        <div className="inline-flex items-center justify-start">
          <div className="text-primary-700 flex items-center gap-1 text-sm leading-normal font-medium transition-all ease-in-out hover:gap-2">
            {cta} <IconMdi path={mdiArrowRight} />
          </div>
        </div>
      </div>
    </div>
  );
};
